export const TICKET_TYPE_OVERDUE_ID = '-1';
export const TICKET_TYPE_EPISODES_ID = '-2';
export const TICKET_TYPE_NON_EPISODES_ID = '-3';
export const TICKET_TYPE_CALLBACK_ID = '-4';
export const TICKET_TYPE_ORAL_ONCO_REPORT_ID = '-5';
export const TICKET_TYPE_ORAL_ONCO_OVERDUE_ID = '-6';
export const TICKET_TYPE_SYMPTOM_ASSESSMENT_REPORT_ID = '-7';
